
/**
 * For Node.js, simply re-export the core `util.deprecate` function.
 */

module.exports = require('util').deprecate;



//////////////////
// WEBPACK FOOTER
// ./~/util-deprecate/node.js
// module id = 340
// module chunks = 0